/*marathonApp.filter('unsafe', ['$sce', function ($sce) { //For use with returning sanitized content through ng-bind-html 
    return $sce.trustAsHtml;
}]);*/